<template>
    <div>
        <v-container>
            <v-row align="center" justify="center"> 
                <v-col cols="12" sm="12" lg="9">
                <h1 class="text-center"> Marketing Sheets</h1>
                <p class="text-center"> Download these informational 1-page marketing sheets and share them with your clients to help them understand what BizPro is, the most valuable courses it includes, and how it could benefit their businessess.</p>
                <p class="text-center">There are 4 versions available, with different branding and customization options:</p>
                </v-col>
            </v-row>
            <v-row >
                <v-col cols="12" sm="12" lg="6">
                    <v-card class="pa-2">
                        <h2 class="text-center"> BizPro Branded</h2>
                        <v-row>
                            <v-col cols="12" sm="12" lg="6" class="text-center">
                                <v-img height="auto" width="auto" src="flyer1.jpg" style="border:1px solid #888"></v-img>
                                <p class="text-center mt-3"> Customizable</p>
                                <v-btn color="blue" dark small href="BizPro_Client_Flyer-Fillable.pdf" target="_blank" class="text-center">Download</v-btn>
                            </v-col>
                            <v-col cols="12" sm="12" lg="6" class="text-center">
                                <v-img height="auto" width="auto" src="flyer-client1.jpg" style="border:1px solid #888"></v-img>
                                <p class="text-center mt-3"> Standard</p>
                                <v-btn color="blue" dark small href="BizPro_Client_Flyer-No-Fill.pdf" target="_blank" class="text-center">Download</v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" lg="6">
                    <v-card class="pa-2">
                        <h2 class="text-center">ADP | BizPro Branded</h2>
                        <v-row>
                            <v-col cols="12" sm="12" lg="6" class="text-center">
                                <v-img height="auto" width="auto" src="BizPro_Client_Flyer_Fillable_ADP.jpg" style="border:1px solid #888"></v-img>
                                <p class="text-center mt-3"> Customizable</p>
                                <v-btn color="blue" dark small href="BizPro_Client_Flyer_Fillable_ADP.pdf" target="_blank" class="text-center">Download</v-btn>
                            </v-col>
                            <v-col cols="12" sm="12" lg="6" class="text-center">
                                <v-img height="auto" width="auto"  src="client-flyer-2.jpg" style="border:1px solid #888"></v-img>
                                <p class="text-center mt-3"> Standard</p>
                                <v-btn color="blue" dark small href="BizPro_Client_Flyer_ADP_No_Fill.pdf" target="_blank" class="text-center">Download</v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
             </v-row>
             <v-row >
                <v-col cols="12" sm="12" lg="6">
                    <v-card class="pa-2">
                        <h2 class="text-center">Marketing Video</h2>
                        <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/421248331?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>
                        <v-text-field :label="copyLabel" onclick="this.select()" outlined hide-details class="mt-6" ref="copyVimeo" append-icon="content_copy" value="https://vimeopro.com/tarkenton/bizpro-video" @click:append="copyVimeo"></v-text-field>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" lg="6">
                    <v-card class="pa-2 text-center mx-auto" style="height:47%">
                        <h2 class="text-center"> BizPro Course Listings</h2>
                        <v-btn color="blue" dark large href="BizPro-Course-List.pdf" target="_blank" class="text-center mt-6">Download</v-btn>
                    </v-card>
                    <v-card class="mt-6 pa-2 text-center" style="height:47%">
                        <h2 class="text-center"> State Mandated Training Info</h2>
                        <v-btn color="blue" dark large href="https://upneticbizpro.com/state-requirements" target="_blank" class="text-center mt-6">View</v-btn>
                    </v-card>
                </v-col>
                
                    
                
              </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'marketing',
        data: () => ({
            copyLabel: 'Click to Copy'
        }),
        methods: {
            copyVimeo(){
                const input = this.$refs.copyVimeo
                input.focus()
                document.execCommand('selectAll')
                this.copied = document.execCommand('copy')
                this.copyLabel = "Copied to Clipboard"
                setTimeout( ()=> {
                    this.copyLabel = 'Click to Copy'
                }, 2000 )
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>